module.exports = __webpack_public_path__ + "3ee8cf652c08fd148af2dc2bf922d20d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/cantons_treemap_mobile.svg
// module id = 141
// module chunks = 1